import { useEffect, useState,useContext } from "react";
import axios from "axios";
import { Container } from "react-bootstrap";
import { LanguageContext } from "../components/context/LanguageContext";
const Faqs = () => {
    const [faqs, setFaqs] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
      const { language } = useContext(LanguageContext); // Get selected language
    console.log(language,"faqs----->")
    useEffect(() => {
        axios
          .get(`https://dev-api.rimligtaxi.se/api/v1/faq?language_type=${language}`)
          .then((response) => {
            setFaqs(response?.data);
            setLoading(false);
          })
          .catch((err) => {
            setError(err.message);
            setLoading(false);
          });
      }, [language]);
  return (
           <div className="static_contnet">
           <Container>
           <h2 class="subTitle text-center">FAQ's</h2>
       <ul className="faq">
       {faqs?.map((element,index)=>{
            return(
                <li key={index}>
                    <h4>
                        {element?.question}
                    </h4>
                <p>
                    {element?.answer}
                </p>
                </li>
            )
        })}
       </ul>
        </Container>
    </div>
  )
}

export default Faqs